<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="page-title">
      <i class="pi pi-search"> </i>
      <label class="name">課題・ソリューション検索</label>
    </div>

    <!-- ガード文言 -->
    <p>
      ※各会員の課題・ソリューション等について、当プラットフォーム及び運営事務局(内閣府)が管理・保証するものではありません。
    </p>

    <div class="search-flex">
      <!-- 検索条件入力 -->
      <div class="search-form-area">
        <form
          [formGroup]="c201SearchForm"
          (ngSubmit)="getResultTaskDataList(true)"
        >
          条件を指定して「<i class="pi pi-search"></i>」をクリック
          <div class="p-d-flex p-jc-between">
            <!-- 検索テキスト -->
            <div class="search-text">
              <input
                type="text"
                pInputText
                placeholder="フリーワード検索"
                (focus)="text_focus.toggle($event)"
                (blur)="text_focus.toggle($event)"
                formControlName="freeword"
              />
              <p-overlayPanel #text_focus>
                <ng-template pTemplate>
                  <div class="overlay-search-text">さらに絞り込む</div>
                </ng-template>
              </p-overlayPanel>
            </div>
            <!-- 検索ボタン -->
            <button
              pButton
              type="submit"
              icon="pi pi-search"
              class="button1 search-button"
              (click)="getResultTaskDataList(true)"
            ></button>
          </div>

          <!-- 検索フォーム -->
          <div class="search-form">
            <p-accordion
              [multiple]="true"
              expandIcon="pi pi-plus"
              collapseIcon="pi pi-minus"
            >
              <!-- 課題・ソリューション種別 -->
              <p-accordionTab
                header="課題・ソリューション種別"
                [(selected)]="accordion_agenda_kbn"
              >
                <div class="form">
                  <div>
                    <p-checkbox
                      label="課題"
                      [value]="'1'"
                      [formControl]="c201SearchForm.controls.agenda_kbn"
                    >
                    </p-checkbox>
                  </div>
                  <div>
                    <p-checkbox
                      label="ソリューション"
                      [value]="'2'"
                      [formControl]="c201SearchForm.controls.agenda_kbn"
                    >
                    </p-checkbox>
                  </div>
                </div>
              </p-accordionTab>
              <!-- 会員種別 -->
              <p-accordionTab
                header="会員種別"
                [(selected)]="accordion_class_id"
              >
                <div class="form">
                  <div *ngFor="let dicData of getDicList(1)">
                    <p-checkbox
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      [formControl]="c201SearchForm.controls.class_id"
                    ></p-checkbox>
                  </div>
                </div>
              </p-accordionTab>
              <!-- カテゴリ -->
              <p-accordionTab
                header="カテゴリ"
                [(selected)]="accordion_category"
              >
                <div *ngFor="let category of categoryList">
                  <!-- カテゴリ大項目 -->
                  <p-accordionTab
                    [(selected)]="accordion_category_detail[category.class_cd1]"
                  >
                    <ng-template pTemplate="header">
                      <p-checkbox
                        [label]="category.class_name1"
                        [value]="category.class_cd1"
                        (onChange)="checkLargeCategory($event, category.rec)"
                        [formControl]="c201SearchForm.controls.category"
                      >
                      </p-checkbox>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <!-- カテゴリ中項目 -->
                      <div class="form">
                        <div *ngFor="let list of category.rec">
                          <p-checkbox
                            [label]="list.class_name2"
                            [value]="list.value"
                            (onChange)="
                              checkMediumCategory(
                                $event,
                                category.class_cd1,
                                category.rec
                              )
                            "
                            [formControl]="c201SearchForm.controls.category"
                          ></p-checkbox>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </div>
              </p-accordionTab>
              <!-- 地域 -->
              <p-accordionTab
                header="地域"
                [(selected)]="accordion_prefectures"
              >
                <div *ngFor="let prefectures of prefecturesList">
                  <!-- 地域大項目 -->
                  <p-accordionTab
                    [(selected)]="
                      accordion_prefectures_detail[prefectures.code]
                    "
                  >
                    <ng-template pTemplate="header">
                      <p-checkbox
                        [label]="prefectures.name"
                        [value]="prefectures.code"
                        (onChange)="
                          checkLargePrefectures($event, prefectures.list)
                        "
                        [formControl]="c201SearchForm.controls.prefectures"
                      >
                      </p-checkbox>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <!-- 地域中項目 -->
                      <div class="form">
                        <div *ngFor="let list of prefectures.list">
                          <p-checkbox
                            [label]="list.sp_name"
                            [value]="list.sp_name"
                            (onChange)="
                              checkMediumPrefectures(
                                $event,
                                prefectures.code,
                                prefectures.list
                              )
                            "
                            [formControl]="c201SearchForm.controls.prefectures"
                          ></p-checkbox>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </div>
              </p-accordionTab>
              <!-- 更新日 -->
              <p-accordionTab
                header="更新日"
                [(selected)]="accordion_update_date"
              >
                <div class="form">
                  <div class="p-col-fixed">
                    <p-calendar
                      [showIcon]="true"
                      [showButtonBar]="true"
                      [yearNavigator]="true"
                      [monthNavigator]="true"
                      placeholder="例）2021/07"
                      dateFormat="yy/mm/dd"
                      dataType="string"
                      appendTo="body"
                      yearRange="2000:2999"
                      formControlName="strdate"
                      translate
                    ></p-calendar>
                  </div>
                  <div class="verticalTilde">〜</div>
                  <div class="p-col-fixed">
                    <p-calendar
                      [showIcon]="true"
                      [showButtonBar]="true"
                      [yearNavigator]="true"
                      [monthNavigator]="true"
                      placeholder="例）2021/07"
                      dateFormat="yy/mm/dd"
                      dataType="string"
                      appendTo="body"
                      yearRange="2000:2999"
                      formControlName="enddate"
                      translate
                    ></p-calendar>
                  </div>
                </div>
              </p-accordionTab>
              <!-- 業種 -->
              <p-accordionTab
                header="業種"
                [(selected)]="accordion_industry_id"
              >
                <div class="form">
                  <div *ngFor="let dicData of getDicList(2)">
                    <p-checkbox
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      [formControl]="c201SearchForm.controls.industry_id"
                    ></p-checkbox>
                  </div>
                </div>
              </p-accordionTab>
              <!-- 目指すSDGsゴール -->
              <p-accordionTab
                header="目指すSDGsゴール"
                [(selected)]="accordion_sdgs_goal"
              >
                <div class="form form-sdgs-goal">
                  <div
                    class="checkbox-sdgs-goal p-d-flex p-as-center"
                    *ngFor="let dicData of getDicList(3)"
                  >
                    <p-checkbox
                      [value]="dicData.sp_code"
                      [formControl]="c201SearchForm.controls.sdgs_goal"
                    >
                    </p-checkbox>
                    <div class="image-margin"></div>
                    <img [src]="dicData.sp_ext" alt="image" />
                  </div>
                </div>
              </p-accordionTab>
            </p-accordion>
          </div>

          <!-- 検索ボタン -->
          <div class="p-d-flex p-jc-center">
            <button
              pButton
              type="button"
              label="検索"
              class="button1 new-button"
              (click)="getResultTaskDataList(true)"
            ></button>
          </div>

          <!-- クリアボタン -->
          <p-button
            label="検索条件をクリアする"
            styleClass="p-button-link"
            (click)="resetSearchForm()"
          ></p-button>
        </form>
      </div>
      <!-- 結果表示 -->
      <div class="result-area">
        <!-- レコメンド表示 -->
        <!-- カテゴリが選択されている場合に表示 -->
        <div *ngIf="resultRecommendList.length != 0">
          <!-- タイトル -->
          <div class="recommend-title">
            <label>関連する課題・ソリューション・連携事例</label>
          </div>
          <div class="recommend-border">
            <p-table
              [value]="resultRecommendList"
              [scrollable]="true"
              scrollHeight="130px"
              styleClass="recommend-area"
              selectionMode="single"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th class="rec-kbn">種別</th>
                  <th class="rec-title">タイトル</th>
                  <th class="rec-organization_name">会員名</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-resultrecommend>
                <tr
                  class="list"
                  (click)="
                    moveC301orMoveH301(resultrecommend.kbn, resultrecommend.id)
                  "
                >
                  <!-- 区分 -->
                  <td class="rec-kbn">
                    <!-- 区分が1の場合 -->
                    <p-tag
                      value="課題"
                      styleClass="task-tag"
                      *ngIf="1 == resultrecommend.kbn"
                    ></p-tag>
                    <!-- 区分が2の場合 -->
                    <p-tag
                      value="ソリューション"
                      styleClass="solution-tag"
                      *ngIf="2 == resultrecommend.kbn"
                    ></p-tag>
                    <!-- 区分が1,2以外の場合 -->
                    <p-tag
                      value="連携事例"
                      styleClass="jirei-tag"
                      *ngIf="3 == resultrecommend.kbn"
                    ></p-tag>
                  </td>
                  <!-- タイトル -->
                  <td class="rec-title">
                    {{ resultrecommend.title }}
                  </td>
                  <!-- 会員名 -->
                  <td class="rec-organization_name">
                    {{ resultrecommend.organization_name }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <!-- ページアンカー -->
        <a id="jump-top"></a>

        <p-dataView
          #table
          [value]="resultTaskDataList"
          [paginator]="true"
          [rows]="50"
          [lazy]="true"
          [totalRecords]="totalRecords"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
          [rowsPerPageOptions]="[50, 100, 500, 1000]"
          emptyMessage="データが存在しません"
          layout="grid"
          (onLazyLoad)="getResultTaskDataList(false, $event)"
          (onPage)="jumpTop()"
        >
          <!-- ヘッダー -->
          <ng-template pTemplate="header">
            <!-- 検索結果数 -->
            <div class="p-d-flex p-jc-between result-count-area">
              <div>
                <label class="count"> {{ totalRecords }} </label>
                件（総件数：{{ countTaskData }}件）
              </div>
              <div class="p-as-center p-d-flex">
                <!-- fpt's part start: added check box to filter issues followed -->
                <div
                  class="mr-2 p-d-flex"
                  *ngIf="this.loginUser
                    && this.loginUser.class_id!=9
                    && this.loginUser.class_id!=3"
                >
                  <p-checkbox name="filterFollowed" label="フォローした課題"
                    (onChange)="changeFilterFollowed($event)"
                    [(ngModel)]="isFilterFollowed"
                    [binary]="true"
                  ></p-checkbox>
                </div>
                <!-- fpt's part end -->
                <div class="p-as-center">表示切替：</div>
                <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
              </div>
            </div>
          </ng-template>
          <!-- リスト -->
          <ng-template
            let-resultTaskData
            pTemplate="listItem"
            let-rowIndex="rowIndex"
          >
            <!-- リスト表示 -->
            <p-table
              [value]="[{}]"
              selectionMode="single"
              styleClass="list-area"
            >
              <ng-template pTemplate="header" *ngIf="0 == rowIndex">
                <tr>
                  <th class="No">No</th>
                  <th class="title">タイトル</th>
                  <!-- fpt added: followbutton column -->
                  <th class="follows"></th>
                  <th class="agenda-kbn">種別</th>
                  <th class="full-name">会員名</th>
                  <th class="end_date">掲載終了日</th>
                  <th class="update-datetime">更新日時</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body">
                <tr
                  class="list"
                  (click)="showIssueDialog(resultTaskData.agenda_id,resultTaskData.agenda_kbn)"
                  [class.row-past]="1 == resultTaskData.agenda_kbn && resultTaskData.past_issue == '1'"
                >
                  <td class="No">
                    <a [attr.href]="generateAgendaUrl(resultTaskData.agenda_id, resultTaskData.agenda_kbn)" target="_blank">
                      {{ resultTaskData.agenda_id }}

                    </a>
                  </td>
                  <td
                    class="title"
                    [class.task-data]="1 == resultTaskData.agenda_kbn"
                    [class.solution-data]="2 == resultTaskData.agenda_kbn"
                  >
                    <a [attr.href]="generateAgendaUrl(resultTaskData.agenda_id, resultTaskData.agenda_kbn)" target="_blank">
                      {{ resultTaskData.title }}
                    </a>
                  </td>
                  <!-- fpt's part star: added button follow on list view mode -->
                  <td class="follows" (click)="resultTaskData.past_issue == '0' && resultTaskData.agenda_kbn==1?$event.stopPropagation():null">
                    <div *ngIf="resultTaskData.agenda_kbn==1 && resultTaskData.past_issue == '0'" class="ml-1 p-d-flex p-jc-end" (click)="$event.stopPropagation()">
                      <button
                        pButton
                        *ngIf="resultTaskData.is_followed==0; else followed"
                        type="button"
                        label="課題をフォロー {{resultTaskData.follower_count >= 9999? '(9999)' :
                          resultTaskData.follower_count <= 0 ? '' : '('+resultTaskData.follower_count+')'}}"
                        class="follow-button "
                        (click)="openConfirmFollowdialog(resultTaskData.agenda_id,resultTaskData.member_id,resultTaskData.title)"
                      >
                      </button>
                      <ng-template #followed>
                        <button
                          pButton
                          type="button"
                          label="フォロー済 {{resultTaskData.follower_count >= 9999? '(9999)' :
                          resultTaskData.follower_count <= 0 ? '' : '('+resultTaskData.follower_count+')'}}"
                          class="unFollow-button"
                          (click)="openConfirmUnFollowdialog(resultTaskData.agenda_id,resultTaskData.title)"
                        >
                        </button>
                      </ng-template>
                    </div>
                    <ng-template [ngIf]="!(resultTaskData.agenda_kbn==1 && resultTaskData.past_issue == '0')">
                      <a [attr.href]="generateAgendaUrl(resultTaskData.agenda_id, resultTaskData.agenda_kbn)" target="_blank">&nbsp;</a>
                    </ng-template>
                  </td>
                  <!-- fpt's part ended -->
                  <td class="agenda-kbn">
                    <a [attr.href]="generateAgendaUrl(resultTaskData.agenda_id, resultTaskData.agenda_kbn)" target="_blank">
                    <!-- 区分が1の場合 -->
                    <p-tag
                      value="課題"
                      styleClass="task-tag"
                      *ngIf="1 == resultTaskData.agenda_kbn"
                    ></p-tag>
                    <!-- 区分が2の場合 -->
                    <p-tag
                      value="ソリューション"
                      styleClass="solution-tag"
                      *ngIf="2 == resultTaskData.agenda_kbn"
                    ></p-tag>
                    </a>
                  </td>
                  <td class="full-name">
                    <a [attr.href]="generateAgendaUrl(resultTaskData.agenda_id, resultTaskData.agenda_kbn)" target="_blank">
                    <div class="wraper">
                      <div class="text">
                        {{ resultTaskData.organization_name }}
                      </div>
                      <div class="icon">
                        <img
                          *ngIf="resultTaskData?.flag_future_city =='1'"
                          src="../../../../assets/images/logo2.png"
                          alt="future-city-badge-icon"
                          height="28px"
                        />
                      </div>
                    </div>
                    </a>
                  </td>
                  <td class="end_date">
                    <a [attr.href]="generateAgendaUrl(resultTaskData.agenda_id, resultTaskData.agenda_kbn)" target="_blank">
                    {{ 2 == resultTaskData.agenda_kbn? resultTaskData.end_date +' 掲載終了':resultTaskData.past_issue == '1'? '掲載期間終了':resultTaskData.end_date +' 掲載終了'}}
                    </a>
                  </td>
                  <td class="update-datetime">
                    <a [attr.href]="generateAgendaUrl(resultTaskData.agenda_id, resultTaskData.agenda_kbn)" target="_blank">
                    {{ resultTaskData.update_datetime }}
                    </a>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-template>
          <!-- グリッドアイテム -->
          <ng-template let-resultTaskData pTemplate="gridItem">
            <div class="p-col-12 p-md-6">
              <a
                style="text-decoration:none; color: inherit;"
                class="item-area item"
                [class.item-past]="'1' == resultTaskData.past_issue && 1 == resultTaskData.agenda_kbn"
                (click)="showIssueDialog(resultTaskData.agenda_id,resultTaskData.agenda_kbn)"
                [attr.href]="generateAgendaUrl(resultTaskData.agenda_id, resultTaskData.agenda_kbn)"
                target="_blank"
              >
                <div class="item-tite-area">
                  <div
                    class="title"
                    [class.task-data]="1 == resultTaskData.agenda_kbn"
                    [class.solution-data]="2 == resultTaskData.agenda_kbn"
                  >
                    {{ resultTaskData.title }}
                  </div>
                  <!-- fpt's part start: add button follow on grid view mode -->
                  <div *ngIf="resultTaskData.agenda_kbn==1 && resultTaskData.past_issue == '0'" class="ml-1 p-d-flex p-jc-end">
                    <button
                      pButton
                      *ngIf="resultTaskData.is_followed==0; else followed"
                      type="button"
                      label="課題をフォロー {{resultTaskData.follower_count >= 9999? '(9999)' :
                      resultTaskData.follower_count <= 0 ? '' : '('+resultTaskData.follower_count+')'}}"
                      class="follow-button "
                      (click)="$event.stopPropagation(); $event.preventDefault(); openConfirmFollowdialog(resultTaskData.agenda_id,resultTaskData.member_id,resultTaskData.title)"
                    >
                    </button>
                    <ng-template #followed>
                      <button
                        pButton
                        type="button"
                        label="フォロー済 {{resultTaskData.follower_count >= 9999? '(9999)' :
                        resultTaskData.follower_count <= 0 ? '' : '('+resultTaskData.follower_count+')'}}"
                        [disabled]="!loginUser"
                        class="unFollow-button"
                        (click)="$event.stopPropagation(); $event.preventDefault(); openConfirmUnFollowdialog(resultTaskData.agenda_id,resultTaskData.title)"
                      >
                      </button>
                    </ng-template>
                  </div>
                  <!-- fpt's part end -->
                </div>
                <div class="p-d-flex">
                  <div
                    class="full-name"
                    [class.task-data]="1 == resultTaskData.agenda_kbn"
                    [class.solution-data]="2 == resultTaskData.agenda_kbn"
                  >
                    {{ resultTaskData.organization_name }}
                  </div>
                  <div class="p-as-center end_date">
                    {{ 2 == resultTaskData.agenda_kbn? resultTaskData.end_date +' 掲載終了':resultTaskData.past_issue == '1'? '掲載期間終了':resultTaskData.end_date +' 掲載終了'}}
                  </div>
                </div>
                <div class="p-d-flex">
                  <div class="p-as-center agenda-kbn">
                    <!-- 区分が1の場合 -->
                    <p-tag
                      value="課題"
                      styleClass="task-tag"
                      *ngIf="1 == resultTaskData.agenda_kbn"
                    ></p-tag>
                    <!-- 区分が2の場合 -->
                    <p-tag
                      value="ソリューション"
                      styleClass="solution-tag"
                      *ngIf="2 == resultTaskData.agenda_kbn"
                    ></p-tag>
                  </div>
                  <div class="p-as-center No">
                    No.{{ resultTaskData.agenda_id }}
                  </div>
                  <div class="future-city-badge p-d-flex p-ml-3" *ngIf="resultTaskData?.flag_future_city == '1'">
                    <div class="icon">
                      <img
                        src="../../../../assets/images/logo2.png"
                        alt="future-city-badge-icon"
                      />
                    </div>
                    <div class="text">
                      未来都市
                    </div>
                  </div>
                  <div class="p-as-center update-datetime">
                    {{ resultTaskData.update_datetime }} 更新
                  </div>
                </div>
              </a>
            </div>
          </ng-template>
        </p-dataView>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
<!-- follow/unfollow dialog -->
<app-follow-dialog (returnValue)="getResultTaskDataList(true)"></app-follow-dialog>
<app-issue-detail-dialog></app-issue-detail-dialog>
